import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      height: '100%',
      minHeight: '18rem',
      padding: '1.6rem',

      display: 'flex',
      flexDirection: 'column',

      border: '1px solid #ABABAB',
      borderRadius: 5,
    },
    herbicides: {
      display: 'grid',
      gridTemplateColumns: 'min-content 3fr min-content 3fr',
      gap: '1rem',
      alignItems: 'start',

      '& .MuiTypography-subtitle2, & .MuiTypography-subtitle1': {
        fontSize: '1.2rem',
        lineHeight: '1.4rem',
      },
    },
    cost: {
      marginTop: 'auto',
      paddingTop: '1rem',

      display: 'grid',
      gridTemplateColumns: '58px 3fr min-content 3fr',
      gap: '0 1rem',
      alignItems: 'center',

      '& > :nth-last-child(2)': {
        gridColumn: '3',
      },

      '& .MuiTypography-subtitle2, & .MuiTypography-subtitle1': {
        fontSize: '1.2rem',
        lineHeight: '1.4rem',
      },
    },
  }),
)
